const signInES = {
	title: "Entrar",
	email: "Correo electrónico",
	password: "Contraseña",
	rememberMe: "Recordarme",
	button: "Entrar",
	loading: "Iniciando...",
	forgotPassword: "¿Olvidaste tu contraseña?",
	noAccount: "¿No tienes una cuenta?",
	createCustomer: "Crear una cuenta de cliente",
	registerBusiness: "Registrar tu negocio",
};
export default signInES;
